import {
    ARTICELS_LIST_REQUEST,
    ARTICELS_LIST_REQUEST_SUCCESS,
    ARTICELS_LIST_REQUEST_FAIL,
    ARTICEL_REQUEST,
    ARTICEL_REQUEST_SUCCESS,
    ARTICEL_REQUEST_FAIL,
    ADMIN_ARTICEL_REQUEST,
    ADMIN_ARTICEL_REQUEST_SUCCESS,
    ADMIN_ARTICEL_REQUEST_FAIL,
    ADMIN_ARTICEL_REQUEST_RESET,
} from "./articlesConstants";

export const articlesListReducer = (
    state = {
        categories: [],
        articles: [],
        totalPages: 0,
    },
    action
) => {
    switch (action.type) {
        case ARTICELS_LIST_REQUEST:
            return {
                locading: true,
                ...state,
            };
        case ARTICELS_LIST_REQUEST_SUCCESS:
            return {
                locading: false,
                categories: action.payload.categories,
                articles: action.payload.articles,
                totalPages: action.payload.totalPages,
            };
        case ARTICELS_LIST_REQUEST_FAIL:
            return { locading: false, error: action.payload };
        default:
            return state;
    }
};

export const articleDetailsReducer = (
    state = {
        loading: true,
    },
    action
) => {
    switch (action.type) {
        case ARTICEL_REQUEST:
            return {
                loading: true,
                ...state,
            };
        case ARTICEL_REQUEST_SUCCESS:
            return {
                loading: false,
                id: action.payload.id,
                userId: action.payload.user.userId,
                fullName: action.payload.user.fullName,
                userImgURL: action.payload.user.imgURL,
                categoryId: action.payload.categoryId,
                date: action.payload.date,
                imgURL: action.payload.imgURL,
                shortDescription: action.payload.shortDescription,
                title: action.payload.title,
                text: action.payload.text,
            };
        case ARTICEL_REQUEST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const adminArticleDetailsReducer = (
    state = {
        loading: true,
    },
    action
) => {
    switch (action.type) {
        case ADMIN_ARTICEL_REQUEST:
            return {
                loading: true,
                ...state,
            };
        case ADMIN_ARTICEL_REQUEST_SUCCESS:
            return {

                loading: false,
                id: action.payload.id,
                categoryId: action.payload.categoryId,
                imgURL: action.payload.imgURL,
                shortDescription: action.payload.shortDescription,
                title: action.payload.title,
                text: action.payload.text,
                arTitle: action.payload.arTitle,
                arShortDescription: action.payload.arShortDescription,
                arText: action.payload.arText,
            };
        case ADMIN_ARTICEL_REQUEST_FAIL:
            return { loading: false, error: action.payload };
        case ADMIN_ARTICEL_REQUEST_RESET:
            return {};
        default:
            return state;
    }
};
